let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("izW66")).then(() => parcelRequire('kcxr2'));